var b = { exports: {} }, M = b.exports, T;
function R() {
  return T || (T = 1, (function(Y, L) {
    (function(w, p) {
      p(L);
    })(M, (function(w) {
      var p = "javascript/blocked", o = { blacklist: window.YETT_BLACKLIST, whitelist: window.YETT_WHITELIST }, m = { blacklisted: [] }, d = function(r, e) {
        return r && (!e || e !== p) && (!o.blacklist || o.blacklist.some((function(t) {
          return t.test(r);
        }))) && (!o.whitelist || o.whitelist.every((function(t) {
          return !t.test(r);
        })));
      }, S = function(r) {
        var e = r.getAttribute("src");
        return o.blacklist && o.blacklist.every((function(t) {
          return !t.test(e);
        })) || o.whitelist && o.whitelist.some((function(t) {
          return t.test(e);
        }));
      }, k = new MutationObserver((function(r) {
        for (var e = 0; e < r.length; e++) for (var t = r[e].addedNodes, i = function(l) {
          var c = t[l];
          if (c.nodeType === 1 && c.tagName === "SCRIPT") {
            var a = c.src, u = c.type;
            d(a, u) && (m.blacklisted.push([c, c.type]), c.type = p, c.addEventListener("beforescriptexecute", (function s(f) {
              c.getAttribute("type") === p && f.preventDefault(), c.removeEventListener("beforescriptexecute", s);
            })), c.parentElement && c.parentElement.removeChild(c));
          }
        }, n = 0; n < t.length; n++) i(n);
      }));
      function A(r, e) {
        var t = Object.keys(r);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(r);
          e && (i = i.filter((function(n) {
            return Object.getOwnPropertyDescriptor(r, n).enumerable;
          }))), t.push.apply(t, i);
        }
        return t;
      }
      function v(r) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e] != null ? arguments[e] : {};
          e % 2 ? A(Object(t), !0).forEach((function(i) {
            I(r, i, t[i]);
          })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : A(Object(t)).forEach((function(i) {
            Object.defineProperty(r, i, Object.getOwnPropertyDescriptor(t, i));
          }));
        }
        return r;
      }
      function I(r, e, t) {
        return e in r ? Object.defineProperty(r, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = t, r;
      }
      function _(r, e) {
        return (function(t) {
          if (Array.isArray(t)) return t;
        })(r) || (function(t, i) {
          var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
          if (n != null) {
            var l, c, a = [], u = !0, s = !1;
            try {
              for (n = n.call(t); !(u = (l = n.next()).done) && (a.push(l.value), !i || a.length !== i); u = !0) ;
            } catch (f) {
              s = !0, c = f;
            } finally {
              try {
                u || n.return == null || n.return();
              } finally {
                if (s) throw c;
              }
            }
            return a;
          }
        })(r, e) || x(r, e) || (function() {
          throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        })();
      }
      function O(r) {
        return (function(e) {
          if (Array.isArray(e)) return E(e);
        })(r) || (function(e) {
          if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
        })(r) || x(r) || (function() {
          throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
        })();
      }
      function x(r, e) {
        if (r) {
          if (typeof r == "string") return E(r, e);
          var t = Object.prototype.toString.call(r).slice(8, -1);
          return t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set" ? Array.from(r) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? E(r, e) : void 0;
        }
      }
      function E(r, e) {
        (e == null || e > r.length) && (e = r.length);
        for (var t = 0, i = new Array(e); t < e; t++) i[t] = r[t];
        return i;
      }
      k.observe(document.documentElement, { childList: !0, subtree: !0 });
      var P = document.createElement, y = { src: Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, "src"), type: Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, "type") };
      document.createElement = function() {
        for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++) e[t] = arguments[t];
        if (e[0].toLowerCase() !== "script") return P.bind(document).apply(void 0, e);
        var i = P.bind(document).apply(void 0, e);
        try {
          Object.defineProperties(i, { src: v(v({}, y.src), {}, { set: function(n) {
            d(n, i.type) && y.type.set.call(this, p), y.src.set.call(this, n);
          } }), type: v(v({}, y.type), {}, { get: function() {
            var n = y.type.get.call(this);
            return n === p || d(this.src, n) ? null : n;
          }, set: function(n) {
            var l = d(i.src, i.type) ? p : n;
            y.type.set.call(this, l);
          } }) }), i.setAttribute = function(n, l) {
            n === "type" || n === "src" ? i[n] = l : HTMLScriptElement.prototype.setAttribute.call(i, n, l);
          };
        } catch {
          console.warn("Yett: unable to prevent script execution for script src ", i.src, `.
`, 'A likely cause would be because you are using a third-party browser extension that monkey patches the "document.createElement" function.');
        }
        return i;
      };
      var C = new RegExp("[|\\{}()[\\]^$+*?.]", "g");
      w.unblock = function() {
        for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++) e[t] = arguments[t];
        e.length < 1 ? (o.blacklist = [], o.whitelist = []) : (o.blacklist && (o.blacklist = o.blacklist.filter((function(a) {
          return e.every((function(u) {
            return typeof u == "string" ? !a.test(u) : u instanceof RegExp ? a.toString() !== u.toString() : void 0;
          }));
        }))), o.whitelist && (o.whitelist = [].concat(O(o.whitelist), O(e.map((function(a) {
          if (typeof a == "string") {
            var u = ".*" + a.replace(C, "\\$&") + ".*";
            if (o.whitelist.every((function(s) {
              return s.toString() !== u.toString();
            }))) return new RegExp(u);
          } else if (a instanceof RegExp && o.whitelist.every((function(s) {
            return s.toString() !== a.toString();
          }))) return a;
          return null;
        })).filter(Boolean)))));
        for (var i = document.querySelectorAll('script[type="'.concat(p, '"]')), n = 0; n < i.length; n++) {
          var l = i[n];
          S(l) && (m.blacklisted.push([l, "application/javascript"]), l.parentElement.removeChild(l));
        }
        var c = 0;
        O(m.blacklisted).forEach((function(a, u) {
          var s = _(a, 2), f = s[0], D = s[1];
          if (S(f)) {
            for (var h = document.createElement("script"), g = 0; g < f.attributes.length; g++) {
              var j = f.attributes[g];
              j.name !== "src" && j.name !== "type" && h.setAttribute(j.name, f.attributes[g].value);
            }
            h.setAttribute("src", f.src), h.setAttribute("type", D || "application/javascript"), document.head.appendChild(h), m.blacklisted.splice(u - c, 1), c++;
          }
        })), o.blacklist && o.blacklist.length < 1 && k.disconnect();
      }, Object.defineProperty(w, "__esModule", { value: !0 });
    }));
  })(b, b.exports)), b.exports;
}
R();
